import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { resetUserMfa } from "./actions";

const ResetUserMfa = ({
  as: As = Button,
  user,
  submitParams,
  onReset,
  ...props
}) => (
  <ModalBuilder
    submitAction={resetUserMfa}
    submitParams={{
      ...submitParams,
    }}
    onSubmitted={onReset}
    renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
    renderModal={(modalProps) => (
      <Modal.Confirmation
        {...modalProps}
        header="Reset Multi-Factor Authentication"
      >
        <p>
          Are you sure you wish to reset multi-factor authentication for{" "}
          {user.firstName} {user.lastName}?
        </p>
        <p>
          They will need to set up multi-factor authentication again next time
          they log in.
        </p>
      </Modal.Confirmation>
    )}
  />
);

export default ResetUserMfa;
